import { render } from "./BInput.vue?vue&type=template&id=60fc53d4"
import script from "./BInput.vue?vue&type=script&lang=js"
export * from "./BInput.vue?vue&type=script&lang=js"
script.render = render

export default script